import React from 'react'
import {
  Autocomplete,
  Box,
  CircularProgress,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import { Controller } from 'react-hook-form'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/Add'
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/Remove'

export const PersonnelDetails = ({
  items,
  label,
  textLabel,
  control,
  register,
  isLoading,
  users,
  onAddPressed,
  onRemove
}) => {
  return (
    <Stack direction="column" spacing={1} sx={{ marginBottom: '0.5em' }}>
      <Typography variant="h5" component="h5" sx={{ margin: '0.5em 0 0.2em' }}>
        {label}
      </Typography>
      {items.map((contact, i) => {
        return (
          <Stack
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            key={contact.id}
            direction="row"
            sx={{
              marginBottom: '.6em !important'
            }}
            mb={2}>
            <Controller
              control={control}
              name={`${label}.${i}.Shift`}
              render={({ field }) => (
                <Select
                  id="Shift"
                  sx={{
                    width: '25%'
                  }}
                  {...field}>
                  <MenuItem value="Day">Day</MenuItem>
                  <MenuItem value="Night">Night</MenuItem>
                </Select>
              )}
            />
            <Controller
              control={control}
              name={`${label}.${i}.User`}
              render={({ field: { onChange, value } }) => (
                <Autocomplete
                  options={users}
                  value={value || ''}
                  sx={{
                    width: '25%'
                  }}
                  multiple={false}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  getOptionKey={(option) => option.id}
                  getOptionLabel={(data) => data?.name || ''}
                  onChange={(_, value) => {
                    onChange(value)
                  }}
                  renderInput={(params) => <TextField {...params} label={textLabel} variant="standard" />}
                />
              )}
            />
            <TextField
              label="Position"
              placeholder="e.g. Supervisor"
              color="secondary"
              sx={{
                width: '25%'
              }}
              InputLabelProps={{ shrink: true }}
              {...register(`${label}.${i}.Position`, { required: true })}
            />
            <IconButton color="secondary" variant="text" onClick={() => onRemove(i)}>
              <RemoveCircleOutlineOutlinedIcon />
            </IconButton>
          </Stack>
        )
      })}
      <Box>
        {isLoading ? (
          <CircularProgress size={12} />
        ) : (
          <IconButton color="secondary" variant="text" onClick={() => onAddPressed()}>
            <AddCircleOutlineOutlinedIcon />
          </IconButton>
        )}
      </Box>
    </Stack>
  )
}
